// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.paymenttypes.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/paymenttypes/paymenttype/paymenttype.tpl.html',
            controller: 'PaymentTypeController as vm'
        }},
        resolve: {
            paymentType: function() { return {}; },
            isNewPaymentType: function() {return true;},
            accounts: accountsResolver
        }
    });

    $stateProvider.state('base.paymenttypes.paymenttype', {
        url:'/{paymentTypeId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/paymenttypes/paymenttype/paymenttype.tpl.html',
            controller: 'PaymentTypeController as vm'
        }},
        resolve: {
            paymentType: paymentTypeResolver,
            isNewPaymentType: function() {return false;},
            accounts: accountsResolver
        }
    });

}

// @ngInject
function paymentTypeResolver($stateParams, PaymentTypesApiService) {
    return PaymentTypesApiService.getPaymentType($stateParams.paymentTypeId);
}

// @ngInject
function accountsResolver(AccountsApiService) {
    return AccountsApiService.getAccounts();
}


// @ngInject
function PaymentTypeController($state, paymentType, loadSpinnerService, PaymentTypesApiService, ToasterService, confirmationDialogService, $translate, isNewPaymentType, accounts) {
    var vm = this;

    //Properties
    var paymentTypeCopy = {};
    vm.paymentType = paymentType;
    vm.accounts = accounts;
    vm.isNewPaymentType = isNewPaymentType;
    vm.isEditing = vm.isNewPaymentType;

    //Methods
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.savePaymentType = savePaymentType;
    vm.deletePaymentType = deletePaymentType;
    vm.isPaymentTypeCodeValid = isPaymentTypeCodeValid;
    vm.toggleDisplayForm = toggleDisplayForm;

    actipaymentTypee();

    function actipaymentTypee() {
        prepareData();
        if (vm.isNewPaymentType) {
            vm.paymentType = {};
        }

        appendLocalizations(vm.paymentType, vm.languages);
    }

    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function enableEditing() {
        paymentTypeCopy = angular.copy(vm.paymentType);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.paymentType = paymentTypeCopy;
        vm.isEditing = false;
    }

    function savePaymentType() {
        if (vm.isNewPaymentType) {
            // saveNewPaymentType();
        } else {
            updatePaymentType();
        }
    }

    // function saveNewPaymentType() {
    //     loadSpinnerService.start('mainSpinner');
    //     PaymentTypesApiService.createPaymentType(vm.paymentType).then(function(response) {
    //         vm.paymentType = response;
    //         prepareData();
    //         vm.isNewPaymentType = false;
    //         vm.isEditing = false;
    //         $state.go('base.paymentTypes.paymentType', {paymentTypeId: vm.paymentType.id});
    //     }, function(error) {
    //         console.log(error);
    //         ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
    //     }).then(function() {
    //         loadSpinnerService.stop('mainSpinner');
    //     });
    // }

    function updatePaymentType() {
        loadSpinnerService.start('mainSpinner');

        PaymentTypesApiService.updatePaymentType(vm.paymentType).then(function(response) {
            vm.paymentType = response;
            prepareData();
            vm.isNewPaymentType = false;
            vm.isEditing = false;
            $state.go('base.paymenttypes.paymenttype', {paymentTypeId: vm.paymentType.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deletePaymentType() {
        confirmationDialogService
            .showDialog($translate.instant('paymentType.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    PaymentTypesApiService.deletePaymentType(vm.paymentType.id).then(function(response) {
                        vm.paymentType = response;
                        prepareData();
                        vm.isNewPaymentType = false;
                        vm.isEditing = false;
                        $state.go('base.paymentTypes');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(paymentType) {
        paymentType.showEditForm = !paymentType.showEditForm;
    }

    function prepareData() {
        if (vm.paymentType === undefined) {
            return;
        }

        vm.paymentTypeCopy = angular.copy(vm.paymentType);
    }


    function isPaymentTypeCodeValid() {
        if (!vm.paymentType.paymentTypeCode) { return false; }
        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('paymenttypes.paymenttype', [])
    .config(stateConfig)
    .controller('PaymentTypeController', PaymentTypeController);
